export default __webpack_public_path__ + "static/media/signatories.4bda4d39.svg";